import React, { useState, useEffect } from 'react';
import "../Styles/Fact.css";
import '../assets/css/odometer.css'

import Odometer from 'react-odometerjs';


const Fact = () => {

    // setTimeout(function() {
    //     Odometer.innerHTML = 80;
    // });

    return (
        <div className='mt-5'>
<section className="bd-fact-area bd-fact-about-spacing fact-responsive fix py-5">
  <div className="container">
    {/* row: horizontally center columns and vertically center their contents */}
    <div className="row justify-content-center text-center align-items-center">
      
      <div className="col-lg-3 col-sm-6 mb-4">
        {/* bd-fact acts as a full-height flex container for the column */}
        <div className="bd-fact d-flex justify-content-center align-items-center h-100 mt-3">
          <div className="bd-fact-inner d-flex flex-column justify-content-center align-items-center">
            <h2 className="bd-fact-title mb-0">
              <span className="odometer">20</span>+
            </h2>
            <span className="bd-fact-subtitle fw-semibold text-white">Satisfied Customers</span>
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-sm-6 mb-4">
        <div className="bd-fact d-flex justify-content-center align-items-center h-100 mt-3">
          <div className="bd-fact-inner d-flex flex-column justify-content-center align-items-center">
            <h2 className="bd-fact-title mb-0">
              <span className="odometer" data-count="80">50</span>+
            </h2>
            <span className="bd-fact-subtitle fw-semibold text-white">Projects Done</span>
          </div>
        </div>
      </div>

      <div className="col-lg-3 col-sm-6 mb-4">
        <div className="bd-fact d-flex justify-content-center align-items-center h-100 mt-3">
          <div className="bd-fact-inner d-flex flex-column justify-content-center align-items-center">
            <h2 className="bd-fact-title mb-0">
              <span className="odometer" data-count="30">15</span>+
            </h2>
            <span className="bd-fact-subtitle fw-semibold text-white">Team Members</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>


        </div>
    )
}

export default Fact